// extracted by mini-css-extract-plugin
module.exports =  {"link":"link--UIHaQIp7WglAulwdCO0HMw=="};